import styled from 'styled-components';

export const StyledTOCSidebar = styled.div`
  background-color: ${props => props.theme.themeColors.sidebars.background};
  display: flex;
  flex-direction: column;
  height: calc(100% - 145px);
  left: ${props => (props.isOpened ? '0' : `-${props.sidebarWidth}`)};
  overflow-y: auto;
  padding: 1.25em 1.5em;
  position: fixed;
  top: 60px;
  transition: left 0.5s ease;
  width: ${props => props.sidebarWidth};
  z-index: 3000;
`;

export const StyledTOCList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;

  > ul {
    padding-left: 1em;
  }
`;

export const StyledListItem = styled.li`
  border-radius: 4px;
  color: ${props => props.theme.themeColors.sidebars.toc.itemColor};
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 0.25em;
  margin-left: -1.5em;
  padding: 0.5em 1.5em;
  width: calc(100% + 3em);

  &:hover {
    color: ${props => props.theme.themeColors.sidebars.toc.itemColorOnHover};
  }
`;

export const StyledListItemOnActive = styled(StyledListItem)`
  background-color: ${props =>
    props.theme.themeColors.sidebars.toc.itemBackgroundOnActive};
  color: ${props => props.theme.themeColors.sidebars.toc.itemColorOnActive};
  cursor: default;

  &:hover {
    color: ${props => props.theme.themeColors.sidebars.toc.itemColorOnActive};
  }
`;

export const StyledBookTitle = styled.p`
  color: ${props => props.theme.themeColors.sidebars.toc.textColor};
  margin: 0 0 0.75em;
`;

export const StyledBookAuthors = styled.p`
  color: ${props => props.theme.themeColors.sidebars.toc.subTextColor};
  font-size: 14.22px;
  margin: 0 0 1.5rem;
`;

export const StyledLine = styled.hr`
  border: 0.5px solid
    ${props => props.theme.themeColors.sidebars.toc.dividerColor};
  margin-bottom: 1.25em;
  width: 100%;
`;
